import PreviewScreen from '../100-ms-integration/PreviewScreen';
import Conferences from '../100-ms-integration/Conferences';
import { useEffect, useState } from 'react';
import { isValidObject } from '../utils/CommonUtils';
import { getThemeConfigData } from '../services/100-ms-services/ApiUtils';
import { useQuery } from "@apollo/client";
import AppInfoQueries from '../services/AppInfoQueries';
import {Flex} from '@100mslive/roomkit-react';
import {RemoteStopScreenshare} from '../plugins/RemoteStopScreenshare';
//const envPolicyConfig = JSON.parse(process.env.REACT_APP_POLICY_CONFIG || "{}");

let appName;
if (window.location.host.includes("localhost")) {
  appName = "localhost";
} else {
  appName = window.location.host.split(".")[0];
}

document.title =
  process.env.REACT_APP_TITLE || `${appName}'s ${document.title}`;

const EdtechComponent = (props: {
  stateData: any,
  authTokenObj: any,
  onActionPerformed: (roomState: any) => void;
}) => {
  const [logoUrl, setLogoUrl] = useState();
  const foldAccessToken = localStorage.getItem('foldAccessToken');

  useQuery(AppInfoQueries.GET_SUBDOMAIN_FOR_ACCOUNTID, {
    context: {
      headers: {
        fold_access_token: foldAccessToken,
      },
    },
    variables: {
      id: props.authTokenObj.accountId,
    },
    onCompleted: (data: any) => {
      if (data?.accountSubdomainMap) {
        const subDomain = data?.accountSubdomainMap?.subDomain;
        if (isValidObject(props.authTokenObj.authToken)) {
          getThemeConfig(props.authTokenObj.accountId, subDomain);
        } else {
          console.log(
            'getThemeConfig hideLoaderOnUserDataFoundWithLoginSuccess'
          );
        }
      }
    },
  });

  useEffect(()=> {
   
  }, [])

  const getThemeConfig = async (accountId: any, subDomain: string) => {
    const result = await getThemeConfigData(accountId, subDomain);
    if (result.data?.accountThemes?.[0]) {
      const accountTheme = result.data?.accountThemes?.[0];
      const additionalAttributes = JSON.parse(accountTheme?.additionalAttributes || '{}')
      const logoUrl= additionalAttributes?.attachment?.logo?.url || '';
      setLogoUrl(logoUrl);
    }
  };

  const selectedView = (code: string) => {
    let panelElem = <></>;
    switch (code) {
      case 'Preview':
        panelElem = (
          <PreviewScreen
            getUserToken={props.authTokenObj.authToken}
            name={props.authTokenObj.name}
            onJoinClicked={onJoinClicked}
            accountLogo={logoUrl}
          />
        );
        break;
      case 'Connected':
        panelElem = <Conferences meetingUrl={props.authTokenObj.meetingUrl} />;
        break;
      case 'Connecting':
        panelElem = <h1 style={{ color: '#fff' }}>Connecting...</h1>;
        break;
      case 'Reconnecting':
        panelElem = <h1 style={{ color: '#fff' }}>Reconnecting...</h1>;
        break;
      case 'Disconnecting':
        panelElem = <h1 style={{ color: '#fff' }}>Disconnecting...</h1>;
        break;
      case 'Failed':
        panelElem = <h1 style={{ color: '#fff' }}>Failed...</h1>;
        break;
      case 'No_meeting':
        panelElem = <h1 style={{ color: '#fff' }}>No Meeting</h1>;
        break;
      case 'Disconnected':
        panelElem = <h1 style={{ color: '#fff' }}>loading...</h1>;
        break;
      default:
        panelElem = <h1 style={{ color: '#fff' }}>No meeting Preview...</h1>;
        break;
    }
    return panelElem;
  };

  const onJoinClicked = () => {
    props.onActionPerformed('Connected');
  };

  return (
    <div className="App">
      {/* {isValidMeeting() ? (
          <ZoomView meeting={joinMeetingObj} />
        ) : (
          <div>Not valid meeting!</div>
        )} */}
      <Flex className="meetContainer" 
        style={{flex: 1, background: process.env.REACT_APP_THEME === 'light' ? 'white' : 'black' }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, height: '100%', width: '100%' }}>
         {logoUrl &&
          <img
            src={logoUrl}
            alt='logo'
            height='50px'
            width='100px'
            style={{
              margin: 10, position: 'absolute', justifyContent: 'flex-start', alignContent: 'flex-start',
              alignItems: 'flex-start', justifySelf: 'flex-start', marginLeft: 0,
              objectFit: 'contain'
            }}
          />
          }
          <RemoteStopScreenshare />
          {selectedView(props?.stateData?.roomState)}
        </div>
        {/* {isConnected && roomState == 'Connected' ? (
            <Conferences />
          ) : (
            <>
              <h1 style={{color: '#fff'}}>Not isConnected</h1>
            </>
          )} */}
      </Flex>
    </div>
  );
};

export default EdtechComponent;